function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Components from "./components/index";
import defaultPolizaData from "../defaultPoliza";
import "../poliza.scss";
import PolizaGroupButtons, { polizaGroupButtonsMode } from "./components/PolizaGroupButtons";
import { checkIsFormValid } from "../utils";

var PolizaForm = function PolizaForm(props) {
  var _props$companiesOptio = props.companiesOption,
      companiesOption = _props$companiesOptio === void 0 ? [] : _props$companiesOptio,
      _props$defaultPoliza = props.defaultPoliza,
      defaultPoliza = _props$defaultPoliza === void 0 ? defaultPolizaData : _props$defaultPoliza,
      _props$defaultStep = props.defaultStep,
      defaultStep = _props$defaultStep === void 0 ? 1 : _props$defaultStep,
      token = props.token,
      _props$channels = props.channels,
      channels = _props$channels === void 0 ? [] : _props$channels,
      _props$regions = props.regions,
      regions = _props$regions === void 0 ? [] : _props$regions,
      _props$comunas = props.comunas,
      comunas = _props$comunas === void 0 ? [] : _props$comunas,
      _props$banksOption = props.banksOption,
      banksOption = _props$banksOption === void 0 ? [] : _props$banksOption,
      _props$companies = props.companies,
      companies = _props$companies === void 0 ? [] : _props$companies,
      additionalFiles = props.additionalFiles,
      document = props.document,
      assist_card = props.assist_card,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? polizaGroupButtonsMode["new"] : _props$mode,
      endorsement_types = props.endorsement_types,
      cancel_reasons = props.cancel_reasons,
      can_manage_endorsement = props.can_manage_endorsement,
      _props$insuranceBroke = props.insuranceBrokerAgents,
      insuranceBrokerAgents = _props$insuranceBroke === void 0 ? [] : _props$insuranceBroke;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      step = _React$useState2[0],
      setStep = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      poliza = _React$useState4[0],
      setPoliza = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      formIsValid = _React$useState6[0],
      setFormIsValid = _React$useState6[1];

  React.useEffect(function () {
    // Fist step, set default poliza;
    if (!poliza) setPoliza(_objectSpread({}, defaultPoliza)); // When some data is changed, we have to valid data

    setFormIsValid(checkIsFormValid(poliza));
  }, [poliza]);
  React.useEffect(function () {
    // set fist step
    if (!step) setStep(defaultStep || 1);
  }, []);

  var renderStep = function renderStep() {
    switch (step) {
      case 1:
        return /*#__PURE__*/React.createElement(Components.ProposedIncome, {
          poliza: poliza,
          channels: channels,
          onChange: function onChange(newPolizaData) {
            setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          },
          companiesOption: companiesOption,
          companies: companies
        });

      case 2:
        return /*#__PURE__*/React.createElement(Components.ProposedCover, {
          additional_files: additionalFiles,
          document: document,
          assist_card: assist_card,
          regions: regions,
          comunas: comunas,
          poliza: poliza,
          token: token,
          onChange: function onChange(newPolizaData) {
            return setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          }
        });

      case 3:
        return /*#__PURE__*/React.createElement(Components.InsuredItems, {
          poliza: poliza,
          onChange: function onChange(newPolizaData) {
            return setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          },
          onChangeToStep: function onChangeToStep(step) {
            return setStep(step);
          },
          regions: regions,
          comunas: comunas
        });

      case 4:
        return /*#__PURE__*/React.createElement(Components.PaymentMethod, {
          poliza: poliza,
          token: token,
          banksOption: banksOption,
          onChange: function onChange(newPolizaData) {
            setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          },
          companies: companies
        });

      case 5:
        return /*#__PURE__*/React.createElement(Components.BrokerInformation, {
          poliza: poliza,
          insuranceBrokerAgents: insuranceBrokerAgents,
          onChange: function onChange(newPolizaData) {
            setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          }
        });

      case 6:
        return /*#__PURE__*/React.createElement(Components.PolizaPreviewForm, {
          poliza: poliza,
          insuranceBrokerAgents: insuranceBrokerAgents,
          onChange: function onChange(newPolizaData) {
            setPoliza(_objectSpread(_objectSpread({}, poliza), newPolizaData));
          }
        });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-horizontal cntPolizaForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header cardHeader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cardFooter"
  }, /*#__PURE__*/React.createElement(PolizaGroupButtons, {
    step: step,
    token: token,
    poliza: poliza,
    mode: mode,
    changeStep: function changeStep(newStep) {
      return setStep(newStep);
    },
    buttonConfirmDisabled: !formIsValid
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-pills"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 1 ? "active" : ""),
    onClick: function onClick() {
      return setStep(1);
    }
  }, "1. Ingreso Propuesta")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 2 ? "active" : ""),
    onClick: function onClick() {
      return setStep(2);
    }
  }, "2. Car\xE1tula Propuesta")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 3 ? "active" : ""),
    onClick: function onClick() {
      return setStep(3);
    }
  }, "3. Materia Asegurada")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 4 ? "active" : ""),
    onClick: function onClick() {
      return setStep(4);
    }
  }, "4. M\xE9todo de Pago")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 5 ? "active" : ""),
    onClick: function onClick() {
      return setStep(5);
    }
  }, "5. Informaci\xF3n Corredor")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(step === 6 ? "active" : ""),
    onClick: function onClick() {
      return setStep(6);
    }
  }, "6. Vista Previa")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2 stepsInfo"
  }, /*#__PURE__*/React.createElement("span", null, "Paso ", step, " de 5"))), poliza && /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, renderStep()), /*#__PURE__*/React.createElement("div", {
    className: "card-footer cardFooter"
  }, /*#__PURE__*/React.createElement(PolizaGroupButtons, {
    step: step,
    token: token,
    poliza: poliza,
    mode: mode,
    changeStep: function changeStep(newStep) {
      return setStep(newStep);
    },
    buttonConfirmDisabled: !formIsValid
  }))));
};

export default PolizaForm;